import React from 'react';
import { motion } from 'framer-motion';
import controller from '../../../images/Curved-section/PS Controller (1).png';
import Shipped from '../../../images/Curved-section/Shipped (1).png';
import Ordering from '../../../images/Curved-section/ordering.png.png';
import ArrowPC from '../../../images/Curved-section/Arrow 1.png';
import ArrowM from '../../../images/Curved-section/Arrow 2.png';

const HowItWorks = () => {
    return (
        <div className="p-6 bg-blue-500 text-white rounded-lg shadow-lg">
            <div className="curved-section">
                <h1>Як це <span style={{ color: 'red' }}>працює!</span></h1>

                <div className='curved-container'>

                    <motion.div
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1.3 }}
                        viewport={{ once: true }}
                        className="step"
                    >
                        <img src={controller} alt="Иконка контроллера" />
                        <p>Оберіть комплект</p>
                    </motion.div>

                    <img className='curved-section-arrow' src={ArrowPC} alt="Arrow"/>
                    <img className='curved-section-arrow-2' src={ArrowM} alt="Arrow Mobile"/>


                    <motion.div
                        initial={{ opacity: 0, x: 100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1.3, delay: 0.2 }}
                        viewport={{ once: true }}
                        className="step"
                    >
                        <img src={Ordering} alt="Иконка телефона" />
                        <p>Залиште заявку</p>
                    </motion.div>

                    <img className='curved-section-arrow' src={ArrowPC} alt="Arrow"/>
                    <img className='curved-section-arrow-2' src={ArrowM} alt="Arrow Mobile"/>

                    <motion.div
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1.3, delay: 0.4 }}
                        viewport={{ once: true }}
                        className="step"
                    >
                        <img className='shipped-icon' src={Shipped} alt="Иконка доставки"/>
                        <p>Отримуйте того ж дня</p>
                    </motion.div>
                </div>
            </div>
        </div>
    );
};

export default HowItWorks;